<div *ngIf="IsJudge === false && AllJudges?.length > 0" class="centered">
    <button mat-raised-button color="primary" type="button" (click)="ChooseJudge()">Select Judge</button>
    <h2 class="para">Current Judge: {{CurrentJudge}}</h2>
</div>

<p *ngIf="NoJudgingWindow === true">
    Could not find any judging windows
</p>
<div *ngIf="NoNominees">
    <h1>There are no nominees to judge</h1>
    <p>Please contact us if you think this is an error</p>
</div>
<div class="mainpanel" *ngIf="ViewReady === true && NoJudgingWindow === false">
    <form [formGroup]="TieForm" (ngSubmit)="Submit(TieForm)" novalidate>
        <mat-toolbar color="primary">
			<h2 class="mat-title">{{NomType.Description}} Nominees ({{Phase}}) - District: {{Judge.DistrictNumber}}</h2>
        </mat-toolbar>

        <p class="para">
            The judging window for phase {{Window.JudgingPhase}} is {{Window.Open ? 'open' : (Window.Upcoming ? 'not open yet' : (Window.Past ? 'past' : ''))}}.
            The window dates are from {{Window.DateBegin | datefns: 'M/d/yyyy h:mm a'}} to {{Window.DateEnd | datefns: 'M/d/yyyy h:mm a'}}.
        </p>
        <div *ngIf="Window.Open === true && NoNominees === false">
            <p class="para">
                Please rate the following nominees.
                Once a nominee is judged, the row will be colored green.
                <span class="red">Once all nominees are rated, you must finalize your ratings by clicking the 'Finalize Ratings' button below.</span>
                Finalized ratings cannot be changed.
                <span class="red">Your ratings will only be counted if the group is finalized.</span>
            </p>

            <div fxLayout="column" fxLayoutAlign="space-around center">
                <div class="mat-elevation-z10 finalizeBox" fxLayout="row" fxLayoutAlign="space-between center" [class.complete]="Judge.Finalized" [class.notfinalized]="!Judge.Finalized">
                    <span>Finalized: {{Judge.Finalized ? 'Yes' : 'No'}}</span>
                    <button *ngIf="Judge.JudgingPhase === 1 || Judge.JudgingPhase === 3" [disabled]="Judge.Finalized || Judge.NumberCompleted !== Judge.Nominees.length" mat-raised-button color="warn" type="button" (click)="Finalize()">Finalize Ratings</button>
                    <button *ngIf="Judge.JudgingPhase === 2 || Judge.JudgingPhase === 4" [disabled]="Judge.Finalized" mat-raised-button color="warn" type="submit">Finalize Rankings</button>
                </div>

                <table>
                    <thead class="primarybackground500">
                        <tr>
                            <th>Nominee #</th>
                            <th>Status</th>
                            <th>Last Updated</th>
                            <th>Action</th>
                            <th *ngIf="Judge.JudgingPhase === 2 || Judge.JudgingPhase === 4">Rank</th>
                        </tr>
                    </thead>
                    <tbody formArrayName="RankingsList">
                        <ng-container *ngFor="let n of Judge.Nominees; let nomIndex = index" [formGroupName]="nomIndex">
                            <tr [class.complete]="n.Completed">
                                <td>{{n.NominationID}}</td>
                                <td><span *ngIf="n.RatingsAvailable == null">Not Started</span><span *ngIf="n.RatingsAvailable != null">{{n.RatingsGiven}} of {{n.RatingsAvailable}} Rated</span></td>
                                <td>{{n.DateUpdated | date:"M/d/y h:mm a"}}</td>
                                <td>
                                    <button *ngIf="Judge.JudgingPhase === 1 || Judge.JudgingPhase === 3" [disabled]="Judge.Finalized" mat-raised-button color="primary" type="button" (click)="Rate(n)">Rate Nominee</button>
                                    <div *ngIf="Judge.JudgingPhase === 2 || Judge.JudgingPhase === 4">
                                        <button mat-raised-button color="primary" type="button" (click)="ViewForm(nomIndex)">
                                            <span *ngIf="!n?.NominationForm?.ShowingNominationForm">View</span><span *ngIf="n?.NominationForm?.ShowingNominationForm">Hide</span> Nominee Form
                                        </button>
                                    </div>
                                </td>
                                <td *ngIf="Judge.JudgingPhase === 2 || Judge.JudgingPhase === 4">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="Rank" placeholder="Select ranking..." [disabled]="Judge.Finalized">
                                            <mat-option *ngFor="let r of AvailableRanks" [value]="r">{{r}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="TieForm?.get('RankingsList')?.at(nomIndex)?.get('Rank')?.hasError('required')">required</mat-error>
                                        <mat-hint *ngIf="DuplicateExists(nomIndex)">Duplicate Rank</mat-hint>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr *ngIf="n?.NominationForm?.ShowingNominationForm">
                                <td colspan="5" class="form">
                                    <div fxLayout="row wrap" fxLayoutAlign="start start" class="tabs">
                                        <div *ngFor="let sec of n?.NominationForm?.Sections; let tabIndex = index" class="customtab" [class.active]="n?.NominationForm?.SelectedTabIndex === tabIndex" (click)="ChangeTab(nomIndex, tabIndex)">
                                            <span>{{sec.Name}}</span>
                                        </div>
                                    </div>
                                    <div *ngFor="let sec of n?.NominationForm?.Sections; let secIndex = index">
                                        <div *ngIf="n?.NominationForm?.SelectedTabIndex === secIndex" class="section">
                                            <div *ngFor="let q of sec.Questions" class="question">
                                                <h2 *ngIf="q.ShowNarrative">{{q.NarrativeText}}</h2>
                                                <div>
                                                    <span *ngIf="q.ShowNumber">{{q.QuestionNumber}}.</span>
                                                    <span>{{q.QuestionText}}</span>
                                                </div>
                                                <div class="mat-elevation-z5 response">
                                                    <span>{{q.Response}}</span>
                                                    <span *ngIf="q.OtherResponse != null">: {{q.OtherResponse}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</div>
